import { cn } from '@/lib/utils';
import { STRINGS } from '@/strings/strings';

/**
 * Dreamable-branded cover tile. Gradient backdrop matching the page shell
 * (world-aa → dream-navy) with the Dreamable wordmark logo centered. No
 * per-world cover art at launch — `/logo-dreamable.svg` is the single
 * brand asset. If a 512×512 favicon/cover PNG is exported post-batch
 * from Figma, swap the `<img src>` here and also update the artwork array
 * in `useMediaSession.ts` to keep cover + lock-screen in sync.
 *
 * Sizing:
 *   - Mobile/Tablet: fills the layout column, capped at 280 × 280 px via
 *     the parent. Uses `aspect-square` so the container defines both axes.
 *   - Desktop: fixed 320 × 320 px, sits left of the text/controls column.
 *
 * `select-none` + `draggable={false}` on the `<img>` matches the MiniPlayer
 * convention (users who long-press-and-drag on mobile shouldn't trigger
 * browser image-save / drag-and-drop on the cover).
 */
interface NowPlayingCoverProps {
  className?: string;
}

export function NowPlayingCover({ className }: NowPlayingCoverProps) {
  return (
    <div
      className={cn(
        'flex aspect-square w-full max-w-[280px] shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-world-aa to-dream-navy shadow-lg desktop:h-[320px] desktop:w-[320px] desktop:max-w-none',
        className,
      )}
      role="img"
      aria-label={STRINGS.shell.nowPlaying.ariaLabel.cover}
    >
      <img src="/logo-dreamable.svg" alt="" className="h-1/2 w-1/2 select-none" draggable={false} />
    </div>
  );
}
